export enum SETTING_KEY {
  PAGES = 'pages',
  PAGE_CONTENT = 'page_content_',
}
